import { abs, eq, gt, lt, sub, type Decimal } from '../core/decimal.ts';

export interface ComparableMetrics {
  readonly finalNetWorth: Decimal;
  readonly peakNetWorth: Decimal;
  readonly finalCash: Decimal;
  readonly finalInvestment: Decimal;
  readonly finalDebt: Decimal;
  readonly averagePassiveIncome: Decimal;
}

export type Winner = 'planA' | 'planB' | 'tie';

export interface MetricComparison {
  readonly metric: string;
  readonly planAValue: Decimal;
  readonly planBValue: Decimal;
  readonly winner: Winner;
  /** MetricComparison.difference: |planA − planB|. */
  readonly difference: Decimal;
}

const winner = (a: Decimal, b: Decimal, higherBetter: boolean): Winner => {
  if (eq(a, b)) return 'tie';
  return (higherBetter ? gt(a, b) : lt(a, b)) ? 'planA' : 'planB';
};

const ROWS: readonly (readonly [string, keyof ComparableMetrics, boolean])[] = [
  ['Final Net Worth', 'finalNetWorth', true],
  ['Peak Net Worth', 'peakNetWorth', true],
  ['Final Cash', 'finalCash', true],
  ['Final Investments', 'finalInvestment', true],
  ['Final Debt', 'finalDebt', false],
  ['Avg Passive Income', 'averagePassiveIncome', true],
];

/** MetricsCalculator.compare(planA:planB:). */
export const compareMetrics = (planA: ComparableMetrics, planB: ComparableMetrics): readonly MetricComparison[] =>
  ROWS.map(([metric, key, higherBetter]) => ({
    metric,
    planAValue: planA[key],
    planBValue: planB[key],
    winner: winner(planA[key], planB[key], higherBetter),
    difference: abs(sub(planA[key], planB[key])),
  }));
